import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { PLAYLISTS_INITIAL_STATE, PlaylistsState } from './playlists.model';
import { withCallState } from '@shared/store-features/call-state-feature';
import { CallStateEnum } from '@shared/models/call-state.model';
import { SnackbarType } from '@shared/models/app-snackbar.model';
import useSnackbarStore from '@store/snackbar-store/snackbar.store';
import {
  createPlaylist,
  deletePlaylist,
  deletePlaylistsMany,
  editPlaylistRow
} from '@shared/api/entertainment-api/playlists-api';

const { showSnackbar } = useSnackbarStore.getState();

const usePlaylistsStore = create<PlaylistsState>()(
  devtools(
    (set, getState) => ({
      ...PLAYLISTS_INITIAL_STATE,
      ...withCallState(getState),

      createRow: async ({ data, state, handleClose }): Promise<any> => {
        set({ callState: CallStateEnum.Loading });
        try {
          const res = await createPlaylist(data);
          set({ callState: CallStateEnum.Loaded });
          handleClose?.();
          if (state) state.setApiFunctionAndFetchData(state.apiFunction);
          showSnackbar('snackbar_success_text', SnackbarType.Success);
          return res;
        } catch (error) {
          set({ callState: CallStateEnum.Error });
          if (error instanceof Error) {
            showSnackbar(error.message, SnackbarType.Error);
            return null;
          }
        }
      },
      editRow: async ({ data, state, handleClose }) => {
        set({ callState: CallStateEnum.Loading });
        try {
          await editPlaylistRow(data);
          set({ callState: CallStateEnum.Loaded });
          handleClose?.();
          state.setApiFunctionAndFetchData(state.apiFunction);
          showSnackbar('snackbar_update_text', SnackbarType.Success);
        } catch (error) {
          set({ callState: CallStateEnum.Error });
          if (error instanceof Error) {
            showSnackbar(error.message, SnackbarType.Error);
          }
        }
      },
      deleteRow: async ({ id, state, handleClose }) => {
        set({ callState: CallStateEnum.Loading });
        try {
          if (id instanceof Array) {
            await deletePlaylistsMany(id);
          } else {
            await deletePlaylist(id);
          }
          set({ callState: CallStateEnum.Loaded });
          handleClose?.();
          state.setApiFunctionAndFetchData(state.apiFunction);
          showSnackbar('snackbar_delete_text', SnackbarType.Success);
        } catch (error) {
          set({ callState: CallStateEnum.Error });
          if (error instanceof Error) {
            showSnackbar(error.message, SnackbarType.Error);
          }
        }
      }
    }),

    { name: 'PlaylistsStore' }
  )
);

export default usePlaylistsStore;
